import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/fin`;
const headers = () => {
  const t = localStorage.getItem("nex_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Any finance write may change the ledger: desk money tiles listen for this and refresh at once.
const changed = (r) => { window.dispatchEvent(new Event("fin:ledger-changed")); return r.data; };

export const finApi = {
  get: (path, params) => axios.get(`${BASE}${path}`, { headers: headers(), params }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: headers() }).then(changed),
  upload: (path, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${BASE}${path}`, fd, { headers: headers() }).then((r) => r.data);
  },
  openFile: (apiUrl) => axios.get(`${process.env.REACT_APP_BACKEND_URL}${apiUrl}`, { headers: headers(), responseType: "blob" })
    .then((r) => window.open(URL.createObjectURL(r.data), "_blank", "noopener")),
  download: (path, params, filename) => axios.get(`${BASE}${path}`, { headers: headers(), params, responseType: "blob" }).then((r) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  }),
  patch: (path, body) => axios.patch(`${BASE}${path}`, body, { headers: headers() }).then(changed),
  del: (path, params) => axios.delete(`${BASE}${path}`, { params, headers: headers() }).then(changed),
};

export const BUCKETS = ["checking", "savings", "loan", "escrow", "program_fee", "payout", "penalty", "payroll", "overhead"];
export const BUCKET_LABEL = { checking: "Cash in Hand", savings: "Savings", loan: "Loan", escrow: "Rent", program_fee: "PACT Fee", payout: "Payout", penalty: "NCN", payroll: "Payroll", overhead: "Overhead" };
/** What the Resident Ledger shows: payroll, rent, case management, loan, cash in hand, savings and NCN (non-compliance notices). */
export const LEDGER_BUCKETS = ["payroll", "escrow", "program_fee", "loan", "checking", "savings", "penalty"];

export const finErr = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || x).join(", ");
  return (typeof d === "string" && d) || e?.message || "Request failed";
};

export const money = (n) => `${n < 0 ? "−" : ""}$${Math.abs(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const isArchived = (r) => r?.status === "archived" || r?.status === "inactive";
/** Current residents first, then archived — each group A→Z by name. */
export const byStatus = (rows = []) => [...rows].sort((a, b) => Number(isArchived(a)) - Number(isArchived(b)) || `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`));

const KEY = (k) => `tea_finance_${k}`;
export const finPref = {
  get: (k, fallback) => localStorage.getItem(KEY(k)) || fallback,
  set: (k, v) => localStorage.setItem(KEY(k), v),
};
